module.exports = __webpack_public_path__ + "img/banner-application.7f753026.png";